export type RequestReadFileData = { file: File };

export const requestReadFile = async ({ file }: RequestReadFileData) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => {
      reader.abort();
      reject(reader.error);
    };
    reader.readAsText(file);
  });
